import { render, staticRenderFns } from "./PlexServer.vue?vue&type=template&id=23b9b7d0&"
import script from "./PlexServer.vue?vue&type=script&lang=js&"
export * from "./PlexServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports